import { render, staticRenderFns } from "./NotificationChild.vue?vue&type=template&id=0c71c4b6&scoped=true"
import script from "./NotificationChild.vue?vue&type=script&lang=js"
export * from "./NotificationChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c71c4b6",
  null
  
)

export default component.exports